import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import cartConfig from "emun.cart/cart.config";
import shoppingConfig from "emun.shopping/shopping.config";
import retailerConfig from "emun.retailer/retailer.config";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";
import resolve from "ioc/resolve";
import required from "emun.order/_required";
// import moment from "moment";$localStorage");
const $localStorage = resolve("$localStorage");
import Product from "emun.shopping/product.model";

export default class ModifyOrderPromptController {
	constructor(options, $session, $location) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = Object.assign({}, cartConfig, shoppingConfig, orderConfig);
		if ($ctrl.$session.isCorpOrAbove()) $ctrl.config.virtualSources = null;
		$ctrl.retailerConfig = retailerConfig;
		$ctrl.labels = labels;
		$ctrl.nextRoute =
			options.nextRoute ||
			$ctrl.config.defaultDetailRoute ||
			"orders.detail.shop";
		const o = Object.assign({}, options.model, options.order);
		//console.debug("options", options);
		//console.debug("o", o.showCode);
		$ctrl.mode = o.mode;
		$ctrl.summary = o.summary;
		$ctrl.bus.send('QueryReasonCodes.json').then(res => $ctrl.reasonCodes = res.data.results);
		$ctrl.order = {
			id: o.id || o.cartId || o.orderId,
			status: o.status || o.orderStatus || o.cartStatus,
			type: o.type || o.transactionType || o.orderType || o.mode,
			shippingLocation: o.shippingLocation,
			purchaser: o.purchaser,
			shippingLocationId: o.shippingLocation
				? o.shippingLocation.id
				: o.shippingLocationId,
			buyer: o.buyer || o.contactId || o.contact,
			paymentTermsId: o.paymentTerms
				? o.paymentTerms.id
				: o.paymentTermsId || $session.meta["DefaultTerms"],
			purchaseOrder: o.purchaseOrder,
			warehouseId:
				o.warehouse && o.warehouse.id ? o.warehouse.id : o.warehouseId,
			containerId:
				o.container && o.container.id ? o.container.id : o.containerId,
			email: o.email,
			phone: o.phone,
			vendorNote: o.vendorNote,
			tagFor: o.tagFor,
			retailerId:
				o.retailer && o.retailer.id
					? o.retailer.id
					: o.purchaser && o.purchaser.id
						? o.purchaser.id
						: o.retailerId,
			shippingMethodId: o.shippingMethod
				? o.shippingMethod.id
				: o.shippingMethodId || $session.meta["DefaultShipMethod"],
			cartName: o.cartName || o.orderPrefix || o.prefix,
			cancelOn: o.cancelOn
				? o.cancelOn
				: $ctrl.config.cancelDateDays
					? moment.utc().startOf("day").add("days", $ctrl.config.cancelDateDays)
					: null,
			shipOns: o.shipOns,
			shipOn: o.shipOn
				? o.shipOn
				: moment
					.utc()
					.startOf("day")
					.add("days", $ctrl.config.shipDateDays || 0),
			note: o.note,
			priceList: o.priceList,
			discountPercentage: o.discountPercentage,
			shipComplete: o.shipComplete || false,
			showCode: o.showCode,
			showCodeId:
				o.showCode && o.showCode.Id
					? o.showCode.id
					: $session.isShowroom()
						? o.showCodeId ||
						$session.meta["ShowCode"] ||
						$session.meta["DefaultOrderSourceShow"]
						: o.showCodeId || "",
			location: o.location,
			exported: o.exported,
			allowBackorders: o.allowBackorders,
			shipCompplete: o.shipComplete,
			location: o.location,
			repFax: o.repFax,
			source: o.source,
			sourceId:
				o.source && o.source.id
					? o.source.id
					: $ctrl.summary
						? "Direct"
						: $session.isShowroom()
							? $session.meta["DefaultOrderSourceShow"]
							: $session.isCorpOrAbove()
								? $session.meta["DefaultOrderSourceCorp"]
								: !$ctrl.config.virtualSources || $ctrl.config.virtualSources == null
									? $session.meta["DefaultOrderSourceRoad"]
									: "",
			vendorId: o.vendor && o.vendor.id ? o.vendor.id : o.vendorId,
			salesRepId: o.salesRepId,
			//writingRepId: o.writingRepId,
			shippingNote:
				o.shippingNote ||
				(!cartConfig.hideShippingNotes && cartConfig.defaultShippingNote
					? cartConfig.defaultShippingNote
					: ""),
			freight: o.freight,
			orderedOn: o.orderedOn,
			canEdit: o.canEdit,
			agencyCanEdit: o.agencyCanEdit,
			resend: false,
			origPO: o.poNumber
		};
		//console.info("BL*** sourceId = " + $ctrl.order.sourceId);
		$ctrl.order.retailer = {
			id: $ctrl.order.retailerId || "",
			companyName:
				o.retailer && o.retailer.companyName
					? o.retailer.companyName
					: o.purchaser && o.purchaser.companyName
						? o.purchaser.companyName
						: o.companyName || "",
		};

		//console.debug("$ctrl.order", { order: $ctrl.order, o });

		$ctrl.$location = resolve("$location");
		$ctrl.title =
			options.title ||
			($ctrl.order.id
				? "Update " + $ctrl.order.id
				: "Create " + (o.mode || "Order")) + "...";
		if (
			$ctrl.config.startOrderMinInfo &&
			$ctrl.order.retailer.id &&
			!$ctrl.order.id &&
			!orderConfig.virtualSources
		) {
			$ctrl.bus
				.send(
					"QueryRetailerShippingLocations.json?Status=Active&op=OrderHeaderFieldset&RetailerId=" +
					$ctrl.order.retailer.id
				)
				.then((res) => {
					if (res.data.results.length === 1) $ctrl.save();
				});
		}
	}

	createShipLocation() {
		let $ctrl = this;
		if ($ctrl.retailerConfig.newLocationConfirmation) {
			return modals
				.confirm(
					"Are you sure you want to create a new shipping location?",
					"Create Shipping Location"
				)
				.result.then(function () {
					$ctrl.$dismiss({ createShippingLocation: $ctrl.order });
				});
		} else {
			$ctrl.$dismiss({ createShippingLocation: $ctrl.order });
		}
	}

	save() {
		const $ctrl = this;
		$ctrl.$close();
/*		$ctrl.order.businessModel = "Wholesale";
		$ctrl.order.purchaser = $ctrl.order.retailer;
		if ($ctrl.summary && !$ctrl.order.id) {
			$ctrl.order.exported = true;
			$ctrl.order.balance =
				$ctrl.order.balanceTotal || $ctrl.order.summaryTotal;
			$ctrl.order.status = "Open";
		}
		if (required.shippingLocationId && $ctrl.order.shippingLocationId === "") {
			modals.alert("You must select a shipping location");
			return;
		}
		if (
			$ctrl.labels.sourceId &&
			$ctrl.config.virtualSources &&
			!$ctrl.$session.hasEnvTag("Showroom") &&
			!$ctrl.order.sourceId
		) {
			modals.alert("You must select an order source");
			return;
		}
		//if (!$ctrl.order.cartName) $ctrl.order.cartName = '' + new Date().getTime();
		const url = `${$ctrl.order.id ? "ApplyOrderHeaderInfo" : "CreateCart"
			}.json?jsconfig=ua,uaa`;
		$ctrl.bus.send(url, $ctrl.order).then(function (response) {
			//console.info("Save $ctrl", $ctrl);
			$ctrl.$cart.ordersInSession().forEach((o) => {
				if (o.id === response.data.id) {
					o.name = response.data.cartName || response.data.id;
					o.companyName = response.data.purchaser.companyName;
					o.customerID = response.data.purchaser.id;
				}
			});
			//if ($ctrl.order.showCodeId) $localStorage.showCodeId = $ctrl.order.showCodeId;
			$ctrl.$emit("orderSaved", $ctrl);
			$ctrl.$cart.load(response.data.id).then(function () {
				//console.info("Close Order $ctrl", $ctrl);
				//console.debug("Close Order $ctrl", $ctrl.order.id, $ctrl.summary, $ctrl.order.vendorId);
				$ctrl.$close(response.data);
				if ($ctrl.order.id == undefined || !$ctrl.order.id) {
					if ($ctrl.summary) {
						//add summary item
						$ctrl.product = new Product({
							id: "SUMMARY",
							unlisted: true,
							vendorId: $ctrl.order.vendorId,
							tag: null,
						});
						$ctrl.product.minimumOrderQty = $ctrl.product.quantity = 1;
						$ctrl.product.wholesalePrice = $ctrl.product.listPrice = $ctrl.product.retailPrice = $ctrl.product.priceOverride = $ctrl.product.price =
							$ctrl.order.summaryTotal;
						$ctrl.product.unlisted = true;
						$ctrl.product.pricing = { 1: $ctrl.product.price };
						if ($ctrl.product.id[0] !== "*")
							$ctrl.product.id = "*" + $ctrl.product.id;
						$ctrl.$cart
							.addItem(
								$ctrl.product.createCartItem(
									null,
									null,
									1,
									$ctrl.product.asShownValues,
									null,
									$ctrl.shipOn || null
								),
								$ctrl.product.optionGroup
									? [$ctrl.product].map((p) => p.id)
									: $ctrl.product
							)
							.then((res) => {
								$ctrl.$emit("cart-item-added", res);
							});
					}
					//console.debug("$ctrl.nextRoute", $ctrl.nextRoute, response.data.id);
					if (
						!$ctrl.$state.current.name.startsWith("shop") &&
						!$ctrl.$state.current.name.startsWith("catalog") &&
						$ctrl.$state.current.name.indexOf("checkout") === -1
					) {
						$ctrl.$state.transitionTo($ctrl.nextRoute, {
							orderId: response.data.id,
						});
					}
				}
			});
		});*/
	}

	delete() {
		const $ctrl = this;
		return modals
			.confirm("Are you sure?", "Delete " + ($ctrl.mode || "Order"))
			.result.then(function () {
				if (!$ctrl.$cart.cancelReasonCode) return modals.alert("Reason code required to cancel order");
				$ctrl.$close($ctrl.order);
				$ctrl.$emit("orderDeleted", $ctrl);
				$ctrl.$cart.cancelled = true;
				//$ctrl.bus
				//	.send("DeleteOrder.json", $ctrl.order)
				//	.then(function (response) {
				//		$ctrl.$close($ctrl.order);
				//		$ctrl.$emit("orderDeleted", $ctrl);
				//		$ctrl.$state.transitionTo("orders");
				//	});
			});
	}
}
